import { render, staticRenderFns } from "./TrainingTrack.vue?vue&type=template&id=2176bfbd&"
import script from "./TrainingTrack.vue?vue&type=script&lang=js&"
export * from "./TrainingTrack.vue?vue&type=script&lang=js&"
import style0 from "./TrainingTrack.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
